import React,{Component} from 'react';
import { firebaseAuth,ref,storage } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

class Avatar extends Component{
    constructor(){
        super();
        this.updateAvatar = this.updateAvatar.bind(this);
        this.state = {
            userId:"",
            user :{},
            path :""
            
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                        let image = data.val().image
                        storage.child("Admin").child(image).getDownloadURL().then(function(url){
                            
                            this.setState({
                            path : url
                            })

                        }.bind(this))
                    }.bind(this));             
            }else{
              this.props.history.push("/login");
            }
        });
       
    }


    updateAvatar(event){
        event.preventDefault();
        //alert("here")
        let file = this.imageFile.files[0];
        if(file){
        let storageRef = storage.child("Admin/"+ file.name);
        let upload = storageRef.put(file);

            upload.on('state_changed', function progress(){

            },function error(err){
                alert("Something went wrong "+err.code)
            },function complete(){
                let updatedProfile = {
                    image : file.name
                } 
                ref.child("users").child(`${this.props.match.params.uid}`).update(updatedProfile).then(()=>{
                 alert("Avatar Uploaded successfully")
                });    
            }.bind(this))
        }else{
            alert("You must select image file ")
            console.log(this.props.match.params.uid)
        }
    }
    
  

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Profile" />
                            <div className="block">
                              <form className="form-horizontal form-bordered" ref={(input) => {this.userForm=input}} onSubmit={this.updateAvatar} >
                                
                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="example-file-input">File input</label>
                                    <div className="col-md-9">
                                        <input type="file" id="example-file-input"  ref={(input) => {this.imageFile =input}} />
                                    </div>
                                </div>

                                <div className="form-group form-actions">
                                    <div className="col-md-9 col-md-offset-3">
                                        <button type="submit" className="btn btn-sm btn-primary" ><i className="fa fa-floppy-o"></i> Change Avatar</button>
                                    </div>
                                </div>
                              </form>

                                
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            
        );
    }
}

export default  Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.js